export default "__VITE_ASSET__qQ0CPlDi__"